export const OFFER_TYPES = {
  phoneOffer: "phoneOffer",
  proposition: "proposition",
  simOnly: "simOnly"
};
